import * as React from 'react';

/** Custom types */
import * as JKYModel from '../../custom-types';

/** Utils */
import { DEFAULT_PLAYER_AUTH } from '../Consts';

const usePlayerHandler = (initialState: JKYModel.PlayerAuth) => {
  const [player, setPlayer] = React.useState(initialState);

  const setSelectedPlayer = (playerAuth: JKYModel.PlayerAuth) => {
    window.localStorage.setItem('SelectedPlayer', JSON.stringify(playerAuth));
    setPlayer(playerAuth);
  };

  const deselectPlayer = () => {
    window.localStorage.removeItem('SelectedPlayer');
    setPlayer(DEFAULT_PLAYER_AUTH);
  };

  return {
    player,
    setSelectedPlayer,
    deselectPlayer,
  };
};

export default usePlayerHandler;
